<template>
  <div class="list-container">
    <div class="filter-container">
      <div class="filter-box">
        <span class="label">客户公司</span>
        <el-input
          v-model="listQuery.name"
          style="width: 200px"
          :size="t('table.btnSize')"
          class="filter-item"
          clearable
          @keyup.enter="handleFilter"
        />
      </div>
      <div class="filter-box">
        <el-button
          v-waves
          class="filter-item "
          type="primary"
          :size="t('table.btnSize')"
          @click="handleFilter"
        >
          {{ t("table.search") }}
        </el-button>
        <el-button
          v-waves
          class="filter-item"
          :size="t('table.btnSize')"
          @click="handleReset"
        >
          {{ t("table.reset") }}
        </el-button>
        <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')" >
          <i class="icon-tubiao-27 iconfont"/>
        </span>
        <span class="svg-icon cursor" @click="handleCommand('column')">
          <i class="icon-tubiao-28 iconfont"/>
        </span>
      </div>
    </div>
    <TableList
      ref="tableListRef"
      v-loading="listLoading"
      :dataList="list"
      :total="total"
      :columnAllData="columnAllData"
      :tableName="TableName"
      :page="listQuery.page"
      :size="listQuery.size"
      :canRefresh="false"
      :canChangeColumn="false"
      :canCommand="false"
      @command-change="handleCommand"
    >
    </TableList>
  </div>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted, ref } from 'vue'
import { PaymentAccountModel } from '@/model/Index'
import { publicPool } from '@/apis/CustomerCompany'
import TableList from '@/components/common/TableList.vue'
import { TableName, permissionName } from '@/utils/enum'
import { TableField } from './FieldTable'
import { pageVo } from '@/utils/index'

import { useI18n } from 'vue-i18n'
export default defineComponent({
  name: 'Publicpool',
  components: {
    TableList
  },
  setup() {
    const { t } = useI18n()
    const tableListRef = ref(null)
    const dataMap = reactive({
      TableName: TableName.TABLE_CUSTOMERPUBLIC,
      permissionName: permissionName.COMPANYTYPE,
      columnAllData: TableField,
      activeId: 0,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        name: undefined,
        ...pageVo
      },
      getList() {
        dataMap.listLoading = true
        publicPool(dataMap.listQuery).then((res: any) => {
          dataMap.list = res.data || []
          dataMap.total = res.total
          dataMap.listLoading = false
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleCommand(command: string, val?: any) {
        switch (command) {
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableListRef.value as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
        }
      },
      handleReset() {
        dataMap.listQuery = {
          name: undefined,
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        dataMap.getList()
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      }
    })
    onMounted(() => {
      dataMap.getList()
    })
    return { t, ...toRefs(dataMap), tableListRef }
  }
})
</script>
<style  lang="scss">

</style>
